<template>
    <div>


<footer class="footer footer-bg" style="background-image: url(../wp-content/uploads/2024/10/footer-bg.png);">
             <div class="p-3">
    <div class="container">
       <div class="row">
        <div class="col-lg-4 col-md-6 pe-lg-5"><a class="footer-logo d-inline-block logo mb-4 ps-4 ms-5" >
                        <img class="img-fluid" src="http://devcdn.wistirna.com/assets/majestic/Majestic_logo.webp" alt="Logo Img" style="filter:brightness(0) invert(1);">
                     </a>
        <aside id="custom_html-3" class="widget_text footer-widget widget widget_custom_html"><div class="textwidget custom-html-widget"><ul class="media-icon list-unstyled">
<li>
<i class="flaticon-pin-1"></i>
<p class="mb-0">From envelopes, packages and boxes to all different kinds of freight, 
  Majestic Courier Inc delivers in the most reliable and cost-effective manner that you require.</p>
</li>


  
</ul>

<div class="d-none">
                  
  <div >
    <h5 style="color: white !important;">Follow Us</h5>
    
  </div>
                  <div class="social-icons mt-2">
                    <ul class="list-inline">
                      <li>
                        <a href="#">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                           <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                         
  <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i class="fab fa-linkedin"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

</div>
</aside>
<!-- <aside id="custom_html-5" class="widget_text footer-widget widget widget_custom_html">
  <div class="textwidget custom-html-widget"><div class="footer-number">
	
	</div></div></aside>  -->
</div>
        <div class="col-lg-8 col-md-6 footer-menu1">
            <div class="row">
            
	
	<div class="col-lg-4 col-md-4 mt-5 mt-lg-0">
            <aside id="nav_menu-3" class="footer-widget widget widget_nav_menu"><h5 class="widget-title">Quick Links</h5><div class="menu-footer-menu-container"><ul id="menu-footer-menu" class="menu">
              <li id="menu-item-2121" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2121">
                <a >Track</a></li>
<li id="menu-item-2122" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2122"><a >Quote</a></li>
<!-- <li id="menu-item-2123" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2123"><a >Terms & Use</a></li>
<li id="menu-item-2124" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2124"><a >Privacy Policy</a></li>
<li id="menu-item-2128" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2128"><a >Cookie Policy</a></li>
<li id="menu-item-2127" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2127"><a >FAQs</a></li> -->

</ul></div></aside>           
 </div>


 <div class="col-lg-8 col-md-8 footer-menu1 mt-5 mt-md-0">
  <aside id="nav_menu-2" class="footer-widget widget widget_nav_menu">
    <h5 class="widget-title">Locations</h5><div class="menu-service-menu-container">

<div class="row">

<div class="col-md-6 mt-2"  v-for=" data of country" :key="data" >

  <div class="d-flex gap-3 pb-2" style="color: white;border-bottom: dashed 1px #374148;">
  <div style="color: red;font-size: 20px;">
     <i class="fa-solid fa-location-dot"></i>
  </div>
  <div style="    line-height: 24px;">
    <div style="font-weight: 600;
    font-size: 17px;">
      {{ data.name }}
    </div>
    <div class="country-email">
      {{ data.number }}
    </div>
    <div class="country-email">
      {{ data.email }}
    </div>
  </div>
</div>

</div>
</div>

  <!-- <ul id="menu-service-menu" class="menu">
    <li id="menu-item-1362" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1362">
    <a><span class="fi fi-au"></span>Australia</a></li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services
 menu-item-1363">
  <a>
<i class="fas fa-phone"></i> 
+61 452 201 075
  </a>
  
</li>
<li id="menu-item-1363"
 class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>
     <i class="fas fa-envelope"></i> 
sales@majesticcourier.com
  </a>
  
</li>

 <li id="menu-item-1362" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1362">
    <a><span class="fi fi-in"></span>India</a></li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>

 <i class="fas fa-phone"></i> +91 81242 43000
  </a>
  
</li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>
    
 <i class="fas fa-envelope"></i> 
india@majesticcourier.com
  </a>
  
</li>



</ul> -->
</div>


</aside>
  </div>


  <!-- <div class="col-lg-4 col-md-4 footer-menu1 mt-5 mt-md-0 d-none">
  <aside id="nav_menu-2" class="footer-widget widget widget_nav_menu">
    <div class="menu-service-menu-container">
  <ul id="menu-service-menu" class="menu">
  



<li id="menu-item-1362" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1362">
    <a><span class="fi fi-lk"></span>Sri Lanka</a></li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>
<i class="fas fa-phone"></i> 
+94 777 312 606
  </a>
  
</li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>
    <i class="fas fa-envelope"></i>
srilanka@majesticcourier.com
  </a>
  
</li>
<li id="menu-item-1362" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1362">
    <a><span class="fi fi-ca"></span>Canada</a></li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>
    <i class="fas fa-phone"></i> 
+1 416 439 4020
  </a>
  
</li>
<li id="menu-item-1363" class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1363">
  <a>
<i class="fas fa-envelope"></i>
canada@majesticcourier.com
  </a>
  
</li>

</ul>
</div>


</aside>
  </div> -->



            </div>




        </div>
	
           
        
      </div>
    </div>
  </div>
    <div class="secondary-footer">
    <div class="container">
        <div class="copyright">
      <div class="row text-center">
        <div class="col">
                          <div class="copyright-text">Copyright © 2020 Majestic Courier Inc. All right reserved.</div>
                        </div>
      </div>
      </div>
    </div>
  </div>
</footer>

    </div>
</template>

<script>
export default{

    data (){
        return{
    country:[

     {
      name:'Australia',
      number:"+61 452 201 075",
      email:"sales@majesticcourier.com"
     },
     {
      name:'India',
      number:"+91 81242 43000",
      email:"india@majesticcourier.com"
     },
     {
      name:'Sri Lanka',
      number:"+94 777 312 606",
      email:"srilanka@majesticcourier.com"
     },
     {
      name:'Switzerland',
      number:"+41 44 315 5840",
      email:"swiz@majesticcourier.com"
     }
    ]

        }
    }
}
</script>

<style scoped>
@import "@/assets/theme-style6c2d.css";

.country-email{
  cursor: pointer;
  color: white;
}
.country-email:hover{
  cursor: pointer;
  color: red;
}
</style>